import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../lib/redux/hooks";
import { EditIcon } from "../../../../../ui/icons/edit";
import { RoundedPlusIcon } from "../../../../../ui/icons/RoundedPlusIcon";
import { TrashIcon } from "../../../../../ui/icons/trash";
import Button from "../../../../../ui/molecules/button";
import { InfoBox } from "../../../../../ui/molecules/infoBox";
import { SelectCustom } from "../../../../../ui/molecules/select";
import { TableSelect } from "../../../../../ui/molecules/tableSelect";
import { formatterDate, optionsFormatter, PaymentTypeOptions, ReimbursementTypeOptions, UsedVehicleOptions } from "../../../../../utils";
import { GestioneRimborsiContext } from "./context";
import { GetAllIVReimbursement, IVReimbursementCreation, IVReimbursementDelete, resetReimbursementCreationRequest, resetReimbursementCreationStatus, resetReimbursementDeleteStatus, setReimbursementCreationAssignmentId, setReimbursementCreationInspectionVisitIds, setReimbursementCreationInspectorCode, setReimbursementCreationReimbursementType } from "./slice";
import { MagnifyingIcon } from "../../../../../ui/icons/magnifying";
import { Alert } from "../../../../../ui/organisms/alert";
import { BigMagnifyingIcon } from "../../../../../ui/icons/BigMagnifyingIcon";
import { PopupForm } from "../../../../../ui/organisms/popupForm";
import { GestioneRimborsiViewPopup } from "./popup";

export function IVGestioneRimborsiEdit() {
    const dispatch = useAppDispatch()
    const reimbursementState = useAppSelector(state => state.reimbursement)
    const assignmentState = useAppSelector(state => state.assignment)
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const [selectedRei, setSelectedRei] = useState<string | null>(null)
    const [showSuccessReimb, setShowSuccessReimb] = useState<boolean>(false)

    useEffect(() => {
        dispatch(resetReimbursementCreationRequest())
    }, [])

    useEffect(() => {

        dispatch(GetAllIVReimbursement({
            itemsPerPage: 0,
            page: 0,
            inspectionVisitId: assignmentState.inspectionVisitIdToUpdate
        }))
        dispatch(setReimbursementCreationAssignmentId(assignmentState.getAssignmentByIdResponse?.id))
        dispatch(setReimbursementCreationInspectorCode(assignmentState.getAssignmentByIdResponse?.inspectorCode))
        dispatch(setReimbursementCreationInspectionVisitIds([assignmentState.inspectionVisitIdToUpdate]))
    }, [reimbursementState.reimbursementCreationRequest.reimbursementType])

    useEffect(() => {
        if (reimbursementState.reimbursementCreationStatus === 'successfully' ||
            reimbursementState.reimbursementDeleteStatus === 'successfully'
        ) {
            dispatch(resetReimbursementCreationStatus())
            dispatch(resetReimbursementDeleteStatus())
            dispatch(GetAllIVReimbursement({
                itemsPerPage: 0,
                page: 0,
                inspectionVisitId: assignmentState.inspectionVisitIdToUpdate
            }))
        }
    }, [reimbursementState.reimbursementCreationStatus,
    reimbursementState.reimbursementDeleteStatus
    ])

    useEffect(() => {
        if (reimbursementState.reimbursementCreationStatus === 'successfully') {
            dispatch(resetReimbursementCreationStatus())
            setShowSuccessReimb(true)
        }
    }, [reimbursementState.reimbursementCreationStatus])

    useEffect(() => {
        if (showSuccessReimb) {
            setTimeout(() => {
                setShowSuccessReimb(false)
            }, 2000)
        }
    }, [showSuccessReimb])

    return (
        <div style={{ padding: '0px 24px 24px 24px' }}>
            <div className="assignment-container">
                <div className="assignment-header text-left">
                    <span className='assignment-title-bold' style={{ color: '#fff' }}>Controlli </span>
                    <span className='assignment-title-bold' style={{ color: '#74A4A9' }}>/</span>
                    <span className='assignment-title-bold' style={{ color: '#d9e6e8' }}> Riepilogo Rimborsi</span>
                </div>

                <div style={{ padding: '24px' }}>
                    <div className="pb-5" style={{ borderBottom: '1px solid #d9e6e8' }}>
                        <InfoBox
                            color="green"
                            table={{
                                title: null,
                                headers: ['Dettagli Visita', 'Costo'],
                                values: [
                                    ['Tipologia Visita: B-', '€110.00'],
                                    ['Prelievo Campioni', '€10.00'],
                                    ['Totale Visita', '€120.00']
                                ]
                            }}
                        />
                    </div>

                    <div className="pt-5 pb-5" style={{ borderBottom: '1px solid #d9e6e8' }}>
                        <div className="assignment-subtitle text-left">
                            Richiedi Rimborso
                        </div>
                        <SelectCustom
                            placeholder="Seleziona tipologia..."
                            options={ReimbursementTypeOptions}
                            value={reimbursementState.reimbursementCreationRequest.reimbursementType}
                            onChange={(value) => dispatch(setReimbursementCreationReimbursementType(value))}
                        />

                        {
                            reimbursementState.reimbursementCreationRequest.reimbursementType && (
                                <div>
                                    <div className="pt-5 pb-5">
                                        <GestioneRimborsiContext />
                                    </div>
                                    {
                                        showSuccessReimb &&
                                        <div className="gap-[8px] text-left" style={{ margin: '24px', borderRadius: '12px', backgroundColor: '#D1F5D9', borderColor: '#8AE59F', borderWidth: 2 }}>
                                            <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                                                Dati salvati correttamente.
                                            </span>
                                        </div>
                                    }
                                    <div style={{ display: 'flex', gap: '24px', justifyContent: 'flex-end' }}>
                                        <Button
                                            variant="solid"
                                            color="dimgrey"
                                            iconPosition="left"
                                            icon={<RoundedPlusIcon />}
                                            size="md"
                                            label="Aggiungi Richiesta"
                                            onClick={() => dispatch(IVReimbursementCreation(reimbursementState.reimbursementCreationRequest))}
                                        />
                                    </div>
                                </div>
                            )
                        }
                    </div>

                    <div className="pt-5 pb-5">
                        <div className="assignment-subtitle text-left pb-3">
                            Riepilogo richieste di rimborso per la visita ispettiva
                        </div>
                        <TableSelect
                            type="radio"
                            headers={['Tipologia Richiesta', 'Data', 'Dati Richiesta', 'Note']}
                            data={
                                reimbursementState.getAllReimbursementResponse?.data.map(r => {
                                    return {
                                        value: r.id!,
                                        labels: [optionsFormatter(r.reimbursementType!, ReimbursementTypeOptions) ?? null, formatterDate(r.day) ?? null, `${r.note}`, r.note ?? null]
                                    }
                                }) || []
                            }
                            onChange={(value) => setSelectedRei(value[0])}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '16px', justifyContent: 'flex-end' }}>
                        <Button
                            disabled={selectedRei === null}
                            variant="solid"
                            color="red"
                            iconPosition="left"
                            icon={<TrashIcon size={20} color="white" />}
                            size="md"
                            label="Elimina richiesta"
                            onClick={() => {
                                setShowAlert(true)
                            }}
                        />

                        <Button
                            disabled={selectedRei === null}
                            variant="outline"
                            color="dimgrey"
                            iconPosition="left"
                            icon={<BigMagnifyingIcon size={20} />}
                            label="Visualizza Richiesta"
                            size="md"
                            onClick={() => {
                                setShowPopup(true)
                            }}
                        />
                    </div>
                </div>
            </div>
            {
                (showAlert && selectedRei) && (
                    <Alert title="Conferma operazione" close={() => setShowAlert(false)}>
                        <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                            <div className="pb-3">
                                <div className="pb-3">
                                    Sei sicuro di voler eliminare la richiesta?
                                </div>
                            </div>
                            <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Button
                                    variant="outline"
                                    color="dimgrey"
                                    iconPosition="off"
                                    label="Annulla"
                                    size="md"
                                    onClick={() => setShowAlert(false)}
                                />
                                <div className="pl-8">
                                    <Button
                                        variant="solid"
                                        color="orange"
                                        iconPosition="off"
                                        label="Elimina"
                                        size="md"
                                        onClick={() => {
                                            dispatch(IVReimbursementDelete(selectedRei))
                                            setShowAlert(false)
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                    </Alert>
                )
            }

            {
                (showPopup && selectedRei) && (
                    <PopupForm headerGreen title="Dettaglio Richiesta" close={() => setShowPopup(false)}>
                        <GestioneRimborsiViewPopup reimbursementId={selectedRei} close={() => setShowPopup(false)} />
                    </PopupForm>
                )
            }
        </div>
    )
}